import React from "react";
import translate from "../../../../translate";

export default function GroupPrivacyWarning({ children }) {
    return <div className={'bg-warning p-1 pl-2 pr-2'}>
        <b>{translate('notice_with_colon')}</b>
        {children}
    </div>
}
